module.exports = __webpack_public_path__ + "media/images/payment/gopay-inverse-31eae8eca01e05888893087a30f97aeb.png";